import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ContactData} from '../../types/organization/contact-data';
import {LocationData} from '../../types/location/location-data';
import {AddContactService} from '../../services/contact/add-contact.service';
import {ENTRY_STATES} from '../../types/entry/EntryStatesEnum';

@Component({
  selector: 'wsd-contacts',
  templateUrl: './contacts.component.html',
  styleUrls: ['./contacts.component.css'],
})
export class ContactsComponent {

  @Input()
  contacts: ContactData[];

  @Input()
  addresses: LocationData[];

  @Input()
  includingPostAddress: boolean = true;

  @Input()
  countryId: number;

  @Input()
  isOrganization: boolean;

  @Output()
  onAddressChange = new EventEmitter<LocationData>();

  constructor(private addContactService: AddContactService) {
  }

  addContact() {
    this.addContactService.create();
  }

  onSave(event) {
    if (event.$state === ENTRY_STATES.NEW) {
      if (event.hasOwnProperty('type')) {
        this.contacts.push(event);
      } else {
        this.addresses.push(event);
      }
    }
  }

  delete(contact: ContactData) {
    this.contacts.splice(this.contacts.indexOf(contact), 1);
  }

  modify(contact: ContactData) {
    this.addContactService.modify(contact);
  }

  deleteAddress(address) {
    this.addresses.splice(this.addresses.indexOf(address), 1);
  }

  modifyAddress(address) {
    this.addContactService.modify(address);
  }

}
